import React from 'react';
import OutsideAlerter from 'components/OutsideAlerter';

// items: Array of { label, onClick, danger? } or false/null (filtered out)
// onClose: if provided, wraps in OutsideAlerter
// top: CSS top offset (default '2.5em')
// align: 'right' | 'left' (default 'right')
function DropdownMenu({ items, top = '2.5em', align = 'right', onClose }) {
    const menu = (
        <div
            className="select-none absolute z-[150] bg-white rounded border border-[#efefef] shadow-[0_8px_16px_rgba(0,0,0,0.15)] py-[0.25em] text-[0.75rem]"
            style={{ top, [align === 'right' ? 'right' : 'left']: 0 }}
        >
            {items.filter(Boolean).map((item, i) =>
                item.divider
                    ? <hr key={i} className="my-[0.25em] border-[#eee]" />
                    : (
                        <a
                            key={i}
                            className="block py-[0.75em] px-[2em] !m-0 whitespace-nowrap cursor-pointer hover:text-[#26AA52]"
                            style={item.danger ? { color: 'red' } : undefined}
                            onClick={item.onClick}
                        >
                            {item.label}
                        </a>
                    )
            )}
        </div>
    );

    return onClose ? <OutsideAlerter onClick={onClose}>{menu}</OutsideAlerter> : menu;
}

export default DropdownMenu;
